export const lifts = Array(20).fill(null).map((value, index, array) => ({id: index, name: 'Some Lift ' + index, trays: []}));

export const liftWithTrays = {
    id: 1,
    name: 'Some Lift',
    trays: [
        {
            id: 1,
            slots: [
                {
                    id: 1,
                    name: 'A'
                },
                {
                    id: 2,
                    name: 'B'
                },
                {
                    id: 3,
                    name: 'C'
                },
                {
                    id: 4,
                    name: 'D'
                },
                {
                    id: 5,
                    name: 'E'
                },
                {
                    id: 6,
                    name: 'F'
                },
                {
                    id: 7,
                    name: 'G'
                },
                {
                    id: 8,
                    name: 'H'
                },
                {
                    id: 9,
                    name: 'I'
                },
                {
                    id: 10,
                    name: 'J'
                },
                {
                    id: 11,
                    name: 'K'
                },
                {
                    id: 12,
                    name: 'L'
                },
                {
                    id: 13,
                    name: 'M'
                },
                {
                    id: 14,
                    name: 'N'
                }
            ]
        }
    ]
};


export const trayWithTools = {
    id: 1,
    slots: [
        {
            id: 1,
            name: 'A',
            tools: [
                {
                    id: 1,
                    name: 'Some tool'
                },
                {
                    id: 2,
                    name: 'Some other tool'
                }
            ]
        },
        {
            id: 2,
            name: 'B',
            tools: [
                {
                    id: 1,
                    name: 'Some tool'
                }
            ]
        },
        {
            id: 3,
            name: 'C',
            tools: [
                {
                    id: 1,
                    name: 'Some tool'
                }
            ]
        },
        {
            id: 4,
            name: 'D',
            tools: [
                {
                    id: 1,
                    name: 'Some tool'
                }
            ]
        },
        {
            id: 5,
            name: 'E',
            tools: [
                {
                    id: 1,
                    name: 'Some tool'
                }
            ]
        },
        {
            id: 6,
            name: 'F'
        },
        {
            id: 7,
            name: 'G'
        },
        {
            id: 8,
            name: 'H'
        },
        {
            id: 9,
            name: 'I'
        },
        {
            id: 10,
            name: 'J'
        },
        {
            id: 11,
            name: 'K'
        },
        {
            id: 12,
            name: 'L'
        },
        {
            id: 13,
            name: 'M'
        },
        {
            id: 14,
            name: 'N'
        },
    ]
}


export const slotWithBatches = {
    id: 1,
    name: 'A',
    batches: [
        {
            id: 1,
            name: 'Some Batch',
            tools: [
                {
                    "tools": [
                        {
                            "id": 4,
                            "toolUid": "9869a47c-c4c5-11e7-abc4-cec278b6b50a",
                            "name": "Tool1",
                            "mainLine": {
                                "id": 1,
                                "name": "Line1"
                            },
                            "owner": {
                                "id": 1,
                                "name": "SuperAdmin SuperAdmin"
                            },
                            "status": "STORED_IN_KARDEX_AVAILABLE_FOR_MANUFACTORING",
                            "mesCode": "mscode",
                            "isAvailableForManufacturing": false
                        }
                    ]
                },
                {
                    "sets": [
                        {
                            "size": 3,
                            "name": "Tool2",
                            "tools": [
                                {
                                    "id": 5,
                                    "name": "Tool2",
                                    "toolUid": "a4827cc0-c4c5-11e7-abc4-cec278b6b50a",
                                    "mainLine": {
                                        "id": 4,
                                        "name": "Line3"
                                    },
                                    "owner": {
                                        "id": 1,
                                        "name": "SuperAdmin SuperAdmin"
                                    },
                                    "status": "STORED_IN_KARDEX_AVAILABLE_FOR_MANUFACTORING",
                                    "mesCode": "mscode",
                                    "isAvailableForManufacturing": false
                                },
                                {
                                    "id": 6,
                                    "toolUid": "a4827cc0-c4c5-11e7-abc4-cec278321s",
                                    "name": "Tool2",
                                    "mainLine": {
                                        "id": 4,
                                        "name": "Line3"
                                    },
                                    "owner": {
                                        "id": 1,
                                        "name": "SuperAdmin SuperAdmin"
                                    },
                                    "status": "STORED_IN_KARDEX_AVAILABLE_FOR_MANUFACTORING",
                                    "mesCode": "mscode",
                                    "isAvailableForManufacturing": false
                                },
                                {
                                    "id": 7,
                                    "toolUid": "a4827cc0-c4c5-11e7-abc4-cec278321s",
                                    "name": "Tool2",
                                    "mainLine": {
                                        "id": 4,
                                        "name": "Line3"
                                    },
                                    "owner": {
                                        "id": 1,
                                        "name": "SuperAdmin SuperAdmin"
                                    },
                                    "status": "STORED_IN_KARDEX_AVAILABLE_FOR_MANUFACTORING",
                                    "mesCode": "mscode",
                                    "isAvailableForManufacturing": false
                                }
                            ]
                        }
                    ]
                },
                {
                    "tools": [
                        {
                            "id": 8,
                            "name": "Tool3",
                            "toolUid": "a4217cc0-c4c5-11e7-abc4-cec278321s",
                            "mainLine": {
                                "id": 1,
                                "name": "Line1"
                            },
                            "owner": {
                                "id": 1,
                                "name": "SuperAdmin SuperAdmin"
                            },
                            "status": "STORED_IN_KARDEX_AVAILABLE_FOR_MANUFACTORING",
                            "mesCode": "string",
                            "isAvailableForManufacturing": false
                        }
                    ]
                },
                {
                    "tools": [
                        {
                            "id": 4,
                            "toolUid": "9869a47c-c4c5-11e7-abc4-cec278b6b50a",
                            "name": "Tool1",
                            "mainLine": {
                                "id": 1,
                                "name": "Line1"
                            },
                            "owner": {
                                "id": 1,
                                "name": "SuperAdmin SuperAdmin"
                            },
                            "status": "STORED_IN_KARDEX_AVAILABLE_FOR_MANUFACTORING",
                            "mesCode": "mscode",
                            "isAvailableForManufacturing": false
                        }
                    ]
                },
                {
                    "sets": [
                        {
                            "size": 3,
                            "name": "Tool2",
                            "tools": [
                                {
                                    "id": 5,
                                    "name": "Tool2",
                                    "toolUid": "a4827cc0-c4c5-11e7-abc4-cec278b6b50a",
                                    "mainLine": {
                                        "id": 4,
                                        "name": "Line3"
                                    },
                                    "owner": {
                                        "id": 1,
                                        "name": "SuperAdmin SuperAdmin"
                                    },
                                    "status": "STORED_IN_KARDEX_AVAILABLE_FOR_MANUFACTORING",
                                    "mesCode": "mscode",
                                    "isAvailableForManufacturing": false
                                },
                                {
                                    "id": 6,
                                    "toolUid": "a4827cc0-c4c5-11e7-abc4-cec278321s",
                                    "name": "Tool2",
                                    "mainLine": {
                                        "id": 4,
                                        "name": "Line3"
                                    },
                                    "owner": {
                                        "id": 1,
                                        "name": "SuperAdmin SuperAdmin"
                                    },
                                    "status": "STORED_IN_KARDEX_AVAILABLE_FOR_MANUFACTORING",
                                    "mesCode": "mscode",
                                    "isAvailableForManufacturing": false
                                },
                                {
                                    "id": 7,
                                    "toolUid": "a4827cc0-c4c5-11e7-abc4-cec278321s",
                                    "name": "Tool2",
                                    "mainLine": {
                                        "id": 4,
                                        "name": "Line3"
                                    },
                                    "owner": {
                                        "id": 1,
                                        "name": "SuperAdmin SuperAdmin"
                                    },
                                    "status": "STORED_IN_KARDEX_AVAILABLE_FOR_MANUFACTORING",
                                    "mesCode": "mscode",
                                    "isAvailableForManufacturing": false
                                }
                            ]
                        }
                    ]
                },
                {
                    "tools": [
                        {
                            "id": 8,
                            "name": "Tool3",
                            "toolUid": "a4217cc0-c4c5-11e7-abc4-cec278321s",
                            "mainLine": {
                                "id": 1,
                                "name": "Line1"
                            },
                            "owner": {
                                "id": 1,
                                "name": "SuperAdmin SuperAdmin"
                            },
                            "status": "STORED_IN_KARDEX_AVAILABLE_FOR_MANUFACTORING",
                            "mesCode": "string",
                            "isAvailableForManufacturing": false
                        }
                    ]
                }
            ]
        },
        {
            id: 2,
            name: 'Some Other Batch',
            tools: [
                {
                    id: 3,
                    name: 'Some tool 2'
                },
                {
                    id: 4,
                    name: 'Some other tool 2'
                }
            ]
        }
    ]
}

export const batchesWithTools = [
    {
        id: 1,
        name: 'Some Batch',
        tools: {
            "totalTools": 16,
            "total": 5,
            "items": [{
                "tools": [{
                    "id": 944,
                    "toolUid": "498d7f92-42e1-4970-afca-012dbfc8cf24",
                    "name": "Upper tool presare conector Daimler MFA AB12",
                    "mesCode": "N/A",
                    "liftNumber": "22",
                    "liftShelf": 1,
                    "cart": 1,
                    "shelfPosition": "A",
                    "isAvailableForManufactoring": true,
                    "notAvailableReason": null,
                    "isDeleted": false,
                    "shouldBeReplaced": false,
                    "mainLine": {"id": 12, "name": "AB12_FA1"},
                    "owner": {"id": 245, "name": "PAZ8BLJ Padurean"},
                    "status": "Depozitat în Lift ",
                    "stance": "",
                    "isInStorage": true,
                    "registeredCycles": null,
                    "registeredTime": null,
                    "comment": null
                }]
            }, {
                "tools": [{
                    "id": 950,
                    "toolUid": "72a36bcc-a03c-4842-8854-8e49351de3df",
                    "name": "Guidance tool presare PCB Ford AB12",
                    "mesCode": "N/A",
                    "liftNumber": "22",
                    "liftShelf": 1,
                    "cart": 1,
                    "shelfPosition": "B",
                    "isAvailableForManufactoring": true,
                    "notAvailableReason": null,
                    "isDeleted": false,
                    "shouldBeReplaced": false,
                    "mainLine": {"id": 12, "name": "AB12_FA1"},
                    "owner": {"id": 245, "name": "PAZ8BLJ Padurean"},
                    "status": "La Linie",
                    "stance": "La linia AB12_FA1",
                    "isInStorage": false,
                    "registeredCycles": null,
                    "registeredTime": null,
                    "comment": null
                }]
            }, {
                "sets": [{
                    "size": 2,
                    "name": "Purtatori EOL Volvo CMA AB12",
                    "tools": [{
                        "id": 984,
                        "toolUid": "f8b3a8ea-d925-4147-9276-5a74278cfb28",
                        "name": "Purtatori EOL Volvo CMA AB12",
                        "mesCode": "N/A",
                        "liftNumber": "22",
                        "liftShelf": 4,
                        "cart": 2,
                        "shelfPosition": "A",
                        "isAvailableForManufactoring": true,
                        "notAvailableReason": null,
                        "isDeleted": false,
                        "shouldBeReplaced": true,
                        "reasonForReplacement": "atom.tool-requests-lines.replaceTools.unavailabilityReason.atOtherLine",
                        "mainLine": {"id": 13, "name": "AB12_FA2"},
                        "owner": {"id": 35, "name": "Neagota Florin"},
                        "status": "La Linie",
                        "stance": "La linia AB12_FA2",
                        "isInStorage": false,
                        "registeredCycles": null,
                        "registeredTime": null,
                        "comment": null
                    }, {
                        "id": 985,
                        "toolUid": "def73fd2-be30-42ce-bb2c-ff64dcb7c674",
                        "name": "Purtatori EOL Volvo CMA AB12",
                        "mesCode": "N/A",
                        "liftNumber": "22",
                        "liftShelf": 4,
                        "cart": 2,
                        "shelfPosition": "A",
                        "isAvailableForManufactoring": true,
                        "notAvailableReason": null,
                        "isDeleted": false,
                        "shouldBeReplaced": true,
                        "reasonForReplacement": "atom.tool-requests-lines.replaceTools.unavailabilityReason.atOtherLine",
                        "mainLine": {"id": 13, "name": "AB12_FA2"},
                        "owner": {"id": 35, "name": "Neagota Florin"},
                        "status": "La Linie",
                        "stance": "La linia AB12_FA2",
                        "isInStorage": false,
                        "registeredCycles": null,
                        "registeredTime": null,
                        "comment": null
                    }]
                }]
            }]
        }
    },
    {
        id: 2,
        name: 'Some Other Batch',
        tools: {
            "totalTools": 2,
            "total": 2,
            "items": [{
                "tools": [{
                    "id": 944,
                    "toolUid": "498d7f92-42e1-4970-afca-012dbfc8cf24",
                    "name": "Upper tool presare conector Daimler MFA AB12",
                    "mesCode": "N/A",
                    "liftNumber": "22",
                    "liftShelf": 1,
                    "cart": 1,
                    "shelfPosition": "A",
                    "isAvailableForManufactoring": true,
                    "notAvailableReason": null,
                    "isDeleted": false,
                    "shouldBeReplaced": false,
                    "mainLine": {"id": 12, "name": "AB12_FA1"},
                    "owner": {"id": 245, "name": "PAZ8BLJ Padurean"},
                    "status": "Depozitat în Lift ",
                    "stance": "",
                    "isInStorage": true,
                    "registeredCycles": null,
                    "registeredTime": null,
                    "comment": null
                }]
            }, {
                "tools": [{
                    "id": 950,
                    "toolUid": "72a36bcc-a03c-4842-8854-8e49351de3df",
                    "name": "Guidance tool presare PCB Ford AB12",
                    "mesCode": "N/A",
                    "liftNumber": "22",
                    "liftShelf": 1,
                    "cart": 1,
                    "shelfPosition": "B",
                    "isAvailableForManufactoring": true,
                    "notAvailableReason": null,
                    "isDeleted": false,
                    "shouldBeReplaced": false,
                    "mainLine": {"id": 12, "name": "AB12_FA1"},
                    "owner": {"id": 245, "name": "PAZ8BLJ Padurean"},
                    "status": "La Linie",
                    "stance": "La linia AB12_FA1",
                    "isInStorage": false,
                    "registeredCycles": null,
                    "registeredTime": null,
                    "comment": null
                }]
            }]
        }
    }
];

export const tools = {
    "totalTools": 285,
    "total": 142,
    "items": [{
        "tools": [{
            "id": 944,
            "toolUid": "498d7f92-42e1-4970-afca-012dbfc8cf24",
            "name": "Upper tool presare conector Daimler MFA AB12",
            "mesCode": "N/A",
            "liftNumber": "22",
            "liftShelf": 1,
            "cart": 1,
            "shelfPosition": "A",
            "isAvailableForManufactoring": true,
            "notAvailableReason": null,
            "isDeleted": false,
            "shouldBeReplaced": false,
            "mainLine": {"id": 12, "name": "AB12_FA1"},
            "owner": {"id": 245, "name": "PAZ8BLJ Padurean"},
            "status": "Depozitat în Lift ",
            "stance": "",
            "isInStorage": true,
            "registeredCycles": null,
            "registeredTime": null,
            "comment": null
        }]
    }, {
        "tools": [{
            "id": 950,
            "toolUid": "72a36bcc-a03c-4842-8854-8e49351de3df",
            "name": "Guidance tool presare PCB Ford AB12",
            "mesCode": "N/A",
            "liftNumber": "22",
            "liftShelf": 1,
            "cart": 1,
            "shelfPosition": "B",
            "isAvailableForManufactoring": true,
            "notAvailableReason": null,
            "isDeleted": false,
            "shouldBeReplaced": false,
            "mainLine": {"id": 12, "name": "AB12_FA1"},
            "owner": {"id": 245, "name": "PAZ8BLJ Padurean"},
            "status": "La Linie",
            "stance": "La linia AB12_FA1",
            "isInStorage": false,
            "registeredCycles": null,
            "registeredTime": null,
            "comment": null
        }]
    }, {
        "sets": [{
            "size": 2,
            "name": "Purtatori EOL Volvo CMA AB12",
            "tools": [{
                "id": 984,
                "toolUid": "f8b3a8ea-d925-4147-9276-5a74278cfb28",
                "name": "Purtatori EOL Volvo CMA AB12",
                "mesCode": "N/A",
                "liftNumber": "22",
                "liftShelf": 4,
                "cart": 2,
                "shelfPosition": "A",
                "isAvailableForManufactoring": true,
                "notAvailableReason": null,
                "isDeleted": false,
                "shouldBeReplaced": true,
                "reasonForReplacement": "atom.tool-requests-lines.replaceTools.unavailabilityReason.atOtherLine",
                "mainLine": {"id": 13, "name": "AB12_FA2"},
                "owner": {"id": 35, "name": "Neagota Florin"},
                "status": "La Linie",
                "stance": "La linia AB12_FA2",
                "isInStorage": false,
                "registeredCycles": null,
                "registeredTime": null,
                "comment": null
            }, {
                "id": 985,
                "toolUid": "def73fd2-be30-42ce-bb2c-ff64dcb7c674",
                "name": "Purtatori EOL Volvo CMA AB12",
                "mesCode": "N/A",
                "liftNumber": "22",
                "liftShelf": 4,
                "cart": 2,
                "shelfPosition": "A",
                "isAvailableForManufactoring": true,
                "notAvailableReason": null,
                "isDeleted": false,
                "shouldBeReplaced": true,
                "reasonForReplacement": "atom.tool-requests-lines.replaceTools.unavailabilityReason.atOtherLine",
                "mainLine": {"id": 13, "name": "AB12_FA2"},
                "owner": {"id": 35, "name": "Neagota Florin"},
                "status": "La Linie",
                "stance": "La linia AB12_FA2",
                "isInStorage": false,
                "registeredCycles": null,
                "registeredTime": null,
                "comment": null
            }]
        }]
    }, {
        "sets": [{
            "size": 5,
            "name": "Purtatori FOI Ford AB12",
            "tools": [{
                "id": 997,
                "toolUid": "280ea67f-cbc3-4180-875c-fdceeebcb25e",
                "name": "Purtatori FOI Ford AB12",
                "mesCode": "N/A",
                "liftNumber": "22",
                "liftShelf": 1,
                "cart": 1,
                "shelfPosition": "B",
                "isAvailableForManufactoring": true,
                "notAvailableReason": null,
                "isDeleted": false,
                "shouldBeReplaced": false,
                "mainLine": {"id": 12, "name": "AB12_FA1"},
                "owner": {"id": 35, "name": "Neagota Florin"},
                "status": "La Linie",
                "stance": "La linia AB12_FA1",
                "isInStorage": false,
                "registeredCycles": null,
                "registeredTime": null,
                "comment": null
            }, {
                "id": 998,
                "toolUid": "829f61a9-9879-4f7b-b4f1-b2ffa9c6ce16",
                "name": "Purtatori FOI Ford AB12",
                "mesCode": "N/A",
                "liftNumber": "22",
                "liftShelf": 1,
                "cart": 1,
                "shelfPosition": "B",
                "isAvailableForManufactoring": true,
                "notAvailableReason": null,
                "isDeleted": false,
                "shouldBeReplaced": false,
                "mainLine": {"id": 12, "name": "AB12_FA1"},
                "owner": {"id": 35, "name": "Neagota Florin"},
                "status": "La Linie",
                "stance": "La linia AB12_FA1",
                "isInStorage": false,
                "registeredCycles": null,
                "registeredTime": null,
                "comment": null
            }, {
                "id": 999,
                "toolUid": "5ca81982-989b-4567-9622-08c0fb601477",
                "name": "Purtatori FOI Ford AB12",
                "mesCode": "N/A",
                "liftNumber": "22",
                "liftShelf": 1,
                "cart": 1,
                "shelfPosition": "B",
                "isAvailableForManufactoring": true,
                "notAvailableReason": null,
                "isDeleted": false,
                "shouldBeReplaced": false,
                "mainLine": {"id": 12, "name": "AB12_FA1"},
                "owner": {"id": 35, "name": "Neagota Florin"},
                "status": "La Linie",
                "stance": "La linia AB12_FA1",
                "isInStorage": false,
                "registeredCycles": null,
                "registeredTime": null,
                "comment": null
            }, {
                "id": 1000,
                "toolUid": "353f6e85-f2d4-48a7-8420-d05910a2407f",
                "name": "Purtatori FOI Ford AB12",
                "mesCode": "N/A",
                "liftNumber": "22",
                "liftShelf": 1,
                "cart": 1,
                "shelfPosition": "B",
                "isAvailableForManufactoring": true,
                "notAvailableReason": null,
                "isDeleted": false,
                "shouldBeReplaced": false,
                "mainLine": {"id": 12, "name": "AB12_FA1"},
                "owner": {"id": 35, "name": "Neagota Florin"},
                "status": "La Linie",
                "stance": "La linia AB12_FA1",
                "isInStorage": false,
                "registeredCycles": null,
                "registeredTime": null,
                "comment": null
            }, {
                "id": 1204,
                "toolUid": "0c379560-fb36-4a72-8f51-5519a67cb1f8",
                "name": "Purtatori FOI Ford AB12",
                "mesCode": "N/A",
                "liftNumber": "22",
                "liftShelf": 1,
                "cart": 1,
                "shelfPosition": "B",
                "isAvailableForManufactoring": true,
                "notAvailableReason": null,
                "isDeleted": false,
                "shouldBeReplaced": false,
                "mainLine": {"id": 12, "name": "AB12_FA1"},
                "owner": {"id": 35, "name": "Neagota Florin"},
                "status": "La Linie",
                "stance": "La linia AB12_FA1",
                "isInStorage": false,
                "registeredCycles": null,
                "registeredTime": null,
                "comment": null
            }]
        }]
    }, {
        "sets": [{
            "size": 2,
            "name": "Screw mask VW AB12",
            "tools": [{
                "id": 1063,
                "toolUid": "4d614403-9495-478f-87e8-30e0e4e93a58",
                "name": "Screw mask VW AB12",
                "mesCode": "N/A",
                "liftNumber": "220",
                "liftShelf": 2,
                "cart": 1,
                "shelfPosition": "b",
                "isAvailableForManufactoring": true,
                "notAvailableReason": null,
                "isDeleted": false,
                "shouldBeReplaced": false,
                "mainLine": {"id": 13, "name": "AB12_FA2"},
                "owner": {"id": 245, "name": "PAZ8BLJ Padurean"},
                "status": "Depozitat în Lift ",
                "stance": "",
                "isInStorage": true,
                "registeredCycles": null,
                "registeredTime": null,
                "comment": null
            }, {
                "id": 1064,
                "toolUid": "c044cedd-a622-4fb9-852d-01609144d9de",
                "name": "Screw mask VW AB12",
                "mesCode": "N/A",
                "liftNumber": "22",
                "liftShelf": 2,
                "cart": 1,
                "shelfPosition": "B",
                "isAvailableForManufactoring": true,
                "notAvailableReason": null,
                "isDeleted": false,
                "shouldBeReplaced": false,
                "mainLine": {"id": 13, "name": "AB12_FA2"},
                "owner": {"id": 245, "name": "PAZ8BLJ Padurean"},
                "status": "Depozitat în Lift ",
                "stance": "",
                "isInStorage": true,
                "registeredCycles": null,
                "registeredTime": null,
                "comment": null
            }]
        }]
    }, {
        "sets": [{
            "size": 3,
            "name": "Milling Cage JLR AB12",
            "tools": [{
                "id": 1081,
                "toolUid": "0938708d-851e-4617-88b4-0a1af10b9370",
                "name": "Milling Cage JLR AB12",
                "mesCode": "N/A",
                "liftNumber": "22",
                "liftShelf": 3,
                "cart": 1,
                "shelfPosition": "B",
                "isAvailableForManufactoring": true,
                "notAvailableReason": null,
                "isDeleted": false,
                "shouldBeReplaced": false,
                "mainLine": {"id": 13, "name": "AB12_FA2"},
                "owner": {"id": 355, "name": "BRN4CLJ Barbaselu"},
                "status": "Depozitat în Lift ",
                "stance": "",
                "isInStorage": true,
                "registeredCycles": null,
                "registeredTime": null,
                "comment": null
            }, {
                "id": 1082,
                "toolUid": "ab58e0ab-d2bb-455b-b6a5-2a1e8ae05334",
                "name": "Milling Cage JLR AB12",
                "mesCode": "N/A",
                "liftNumber": "22",
                "liftShelf": 3,
                "cart": 1,
                "shelfPosition": "B",
                "isAvailableForManufactoring": true,
                "notAvailableReason": null,
                "isDeleted": false,
                "shouldBeReplaced": false,
                "mainLine": {"id": 13, "name": "AB12_FA2"},
                "owner": {"id": 355, "name": "BRN4CLJ Barbaselu"},
                "status": "Depozitat în Lift ",
                "stance": "",
                "isInStorage": true,
                "registeredCycles": null,
                "registeredTime": null,
                "comment": null
            }, {
                "id": 1083,
                "toolUid": "52bed056-b16c-40a8-8871-d728a1d78be6",
                "name": "Milling Cage JLR AB12",
                "mesCode": "N/A",
                "liftNumber": "22",
                "liftShelf": 3,
                "cart": 1,
                "shelfPosition": "B",
                "isAvailableForManufactoring": true,
                "notAvailableReason": null,
                "isDeleted": false,
                "shouldBeReplaced": false,
                "mainLine": {"id": 13, "name": "AB12_FA2"},
                "owner": {"id": 355, "name": "BRN4CLJ Barbaselu"},
                "status": "Depozitat în Lift ",
                "stance": "",
                "isInStorage": true,
                "registeredCycles": null,
                "registeredTime": null,
                "comment": null
            }]
        }]
    }, {
        "tools": [{
            "id": 1105,
            "toolUid": "db99305b-f48a-4e1a-a8b2-cf56c702582f",
            "name": "Upper tool presare conector Hyundai AB12",
            "mesCode": "N/A",
            "liftNumber": "22",
            "liftShelf": 2,
            "cart": 1,
            "shelfPosition": "C",
            "isAvailableForManufactoring": true,
            "notAvailableReason": null,
            "isDeleted": false,
            "shouldBeReplaced": false,
            "mainLine": {"id": 12, "name": "AB12_FA1"},
            "owner": {"id": 245, "name": "PAZ8BLJ Padurean"},
            "status": "Depozitat în Lift ",
            "stance": "",
            "isInStorage": true,
            "registeredCycles": null,
            "registeredTime": null,
            "comment": null
        }]
    }, {
        "tools": [{
            "id": 1114,
            "toolUid": "e549a5ef-bfaf-4e5a-835c-5f873d13cb86",
            "name": "EOL Tester Hyundai 0001 AB12",
            "mesCode": "N/A",
            "liftNumber": "22",
            "liftShelf": 2,
            "cart": 1,
            "shelfPosition": "C",
            "isAvailableForManufactoring": true,
            "notAvailableReason": null,
            "isDeleted": false,
            "shouldBeReplaced": false,
            "mainLine": {"id": 12, "name": "AB12_FA1"},
            "owner": {"id": 1479, "name": "BUR2CLJ Budean"},
            "status": "Depozitat în Lift ",
            "stance": "",
            "isInStorage": true,
            "registeredCycles": null,
            "registeredTime": null,
            "comment": null
        }]
    }, {
        "tools": [{
            "id": 5718,
            "toolUid": "3dbe27a3-bef3-4a78-be9a-a4006e1f4663",
            "name": "Guidance tool presare PCB Fiat 312 AB12",
            "mesCode": "N/A",
            "liftNumber": "220",
            "liftShelf": 5,
            "cart": 2,
            "shelfPosition": "c",
            "isAvailableForManufactoring": true,
            "notAvailableReason": null,
            "isDeleted": false,
            "shouldBeReplaced": false,
            "mainLine": {"id": 12, "name": "AB12_FA1"},
            "owner": {"id": 245, "name": "PAZ8BLJ Padurean"},
            "status": "Depozitat în Lift ",
            "stance": "",
            "isInStorage": true,
            "registeredCycles": null,
            "registeredTime": null,
            "comment": null
        }]
    }, {
        "tools": [{
            "id": 5723,
            "toolUid": "be7cb267-166a-49f1-b018-13d6a2cdb08c",
            "name": "EOL Tester Nissan 0001 AB12",
            "mesCode": "N/A",
            "liftNumber": "22",
            "liftShelf": 2,
            "cart": 1,
            "shelfPosition": "a",
            "isAvailableForManufactoring": true,
            "notAvailableReason": null,
            "isDeleted": false,
            "shouldBeReplaced": true,
            "reasonForReplacement": "atom.tool-requests-lines.replaceTools.unavailabilityReason.notStoredInLift",
            "mainLine": {"id": 12, "name": "AB12_FA1"},
            "owner": {"id": 1479, "name": "BUR2CLJ Budean"},
            "status": "La stația Atom",
            "stance": "Așteptând să fie scanat",
            "isInStorage": false,
            "registeredCycles": null,
            "registeredTime": null,
            "comment": null
        }]
    }, {
        "sets": [{
            "size": 3,
            "name": "Milling cage Nissan AB12",
            "tools": [{
                "id": 5726,
                "toolUid": "fecbe039-9769-4f1b-ae33-cc5384e8e6ac",
                "name": "Milling cage Nissan AB12",
                "mesCode": "N/A",
                "liftNumber": "22",
                "liftShelf": 2,
                "cart": 1,
                "shelfPosition": "A",
                "isAvailableForManufactoring": true,
                "notAvailableReason": null,
                "isDeleted": false,
                "shouldBeReplaced": false,
                "mainLine": {"id": 12, "name": "AB12_FA1"},
                "owner": {"id": 355, "name": "BRN4CLJ Barbaselu"},
                "status": "Depozitat în Lift ",
                "stance": "",
                "isInStorage": true,
                "registeredCycles": null,
                "registeredTime": null,
                "comment": null
            }, {
                "id": 5727,
                "toolUid": "6057d9c6-d21a-4469-be4c-dcd76b6868b0",
                "name": "Milling cage Nissan AB12",
                "mesCode": "N/A",
                "liftNumber": "22",
                "liftShelf": 2,
                "cart": 1,
                "shelfPosition": "A",
                "isAvailableForManufactoring": true,
                "notAvailableReason": null,
                "isDeleted": false,
                "shouldBeReplaced": false,
                "mainLine": {"id": 12, "name": "AB12_FA1"},
                "owner": {"id": 355, "name": "BRN4CLJ Barbaselu"},
                "status": "Depozitat în Lift ",
                "stance": "",
                "isInStorage": true,
                "registeredCycles": null,
                "registeredTime": null,
                "comment": null
            }, {
                "id": 5728,
                "toolUid": "37656399-b23b-46ae-bd1e-047f9e7a2951",
                "name": "Milling cage Nissan AB12",
                "mesCode": "N/A",
                "liftNumber": "22",
                "liftShelf": 2,
                "cart": 1,
                "shelfPosition": "A",
                "isAvailableForManufactoring": true,
                "notAvailableReason": null,
                "isDeleted": false,
                "shouldBeReplaced": false,
                "mainLine": {"id": 12, "name": "AB12_FA1"},
                "owner": {"id": 355, "name": "BRN4CLJ Barbaselu"},
                "status": "Depozitat în Lift ",
                "stance": "",
                "isInStorage": true,
                "registeredCycles": null,
                "registeredTime": null,
                "comment": null
            }]
        }]
    }, {
        "tools": [{
            "id": 5760,
            "toolUid": "1dccc909-b064-4787-97cf-d2435ae06a3e",
            "name": "Upper tool presare PCB Daimler MRA AB12",
            "mesCode": "N/A",
            "liftNumber": "22",
            "liftShelf": 1,
            "cart": 1,
            "shelfPosition": "C",
            "isAvailableForManufactoring": true,
            "notAvailableReason": null,
            "isDeleted": false,
            "shouldBeReplaced": false,
            "mainLine": {"id": 12, "name": "AB12_FA1"},
            "owner": {"id": 245, "name": "PAZ8BLJ Padurean"},
            "status": "Depozitat în Lift ",
            "stance": "",
            "isInStorage": true,
            "registeredCycles": null,
            "registeredTime": null,
            "comment": null
        }]
    }, {
        "sets": [{
            "size": 3,
            "name": "Milling cage Volvo Trucks AB12",
            "tools": [{
                "id": 5764,
                "toolUid": "05f4a119-a17f-4719-9366-1df40bc0d898",
                "name": "Milling cage Volvo Trucks AB12",
                "mesCode": "N/A",
                "liftNumber": "22",
                "liftShelf": 3,
                "cart": 1,
                "shelfPosition": "A",
                "isAvailableForManufactoring": true,
                "notAvailableReason": null,
                "isDeleted": false,
                "shouldBeReplaced": false,
                "mainLine": {"id": 13, "name": "AB12_FA2"},
                "owner": {"id": 355, "name": "BRN4CLJ Barbaselu"},
                "status": "Depozitat în Lift ",
                "stance": "",
                "isInStorage": true,
                "registeredCycles": null,
                "registeredTime": null,
                "comment": null
            }, {
                "id": 5765,
                "toolUid": "1d1d90e0-b704-4f5d-a3ad-ee2cce3c056a",
                "name": "Milling cage Volvo Trucks AB12",
                "mesCode": "N/A",
                "liftNumber": "22",
                "liftShelf": 3,
                "cart": 1,
                "shelfPosition": "A",
                "isAvailableForManufactoring": true,
                "notAvailableReason": null,
                "isDeleted": false,
                "shouldBeReplaced": false,
                "mainLine": {"id": 13, "name": "AB12_FA2"},
                "owner": {"id": 355, "name": "BRN4CLJ Barbaselu"},
                "status": "Depozitat în Lift ",
                "stance": "",
                "isInStorage": true,
                "registeredCycles": null,
                "registeredTime": null,
                "comment": null
            }, {
                "id": 5766,
                "toolUid": "6a5fc746-16cb-4e1c-a989-fa03c4e4a3f4",
                "name": "Milling cage Volvo Trucks AB12",
                "mesCode": "N/A",
                "liftNumber": "22",
                "liftShelf": 3,
                "cart": 1,
                "shelfPosition": "A",
                "isAvailableForManufactoring": true,
                "notAvailableReason": null,
                "isDeleted": false,
                "shouldBeReplaced": false,
                "mainLine": {"id": 13, "name": "AB12_FA2"},
                "owner": {"id": 355, "name": "BRN4CLJ Barbaselu"},
                "status": "Depozitat în Lift ",
                "stance": "",
                "isInStorage": true,
                "registeredCycles": null,
                "registeredTime": null,
                "comment": null
            }]
        }]
    }, {
        "sets": [{
            "size": 4,
            "name": "Purtatori FOI Volvo Trucks AB12",
            "tools": [{
                "id": 5771,
                "toolUid": "f49e700f-4219-4fb7-969b-ba3ec4ee9a86",
                "name": "Purtatori FOI Volvo Trucks AB12",
                "mesCode": "N/A",
                "liftNumber": "22",
                "liftShelf": 3,
                "cart": 1,
                "shelfPosition": "A",
                "isAvailableForManufactoring": true,
                "notAvailableReason": null,
                "isDeleted": false,
                "shouldBeReplaced": false,
                "mainLine": {"id": 13, "name": "AB12_FA2"},
                "owner": {"id": 35, "name": "Neagota Florin"},
                "status": "Depozitat în Lift ",
                "stance": "",
                "isInStorage": true,
                "registeredCycles": null,
                "registeredTime": null,
                "comment": null
            }, {
                "id": 5772,
                "toolUid": "ec7cd96b-5acb-4e5a-99fd-b14744bdb851",
                "name": "Purtatori FOI Volvo Trucks AB12",
                "mesCode": "N/A",
                "liftNumber": "22",
                "liftShelf": 3,
                "cart": 1,
                "shelfPosition": "A",
                "isAvailableForManufactoring": true,
                "notAvailableReason": null,
                "isDeleted": false,
                "shouldBeReplaced": false,
                "mainLine": {"id": 13, "name": "AB12_FA2"},
                "owner": {"id": 35, "name": "Neagota Florin"},
                "status": "Depozitat în Lift ",
                "stance": "",
                "isInStorage": true,
                "registeredCycles": null,
                "registeredTime": null,
                "comment": null
            }, {
                "id": 5773,
                "toolUid": "e00d6eb0-7b68-43a6-be30-0ebb91d051fa",
                "name": "Purtatori FOI Volvo Trucks AB12",
                "mesCode": "N/A",
                "liftNumber": "22",
                "liftShelf": 3,
                "cart": 1,
                "shelfPosition": "A",
                "isAvailableForManufactoring": true,
                "notAvailableReason": null,
                "isDeleted": false,
                "shouldBeReplaced": false,
                "mainLine": {"id": 13, "name": "AB12_FA2"},
                "owner": {"id": 35, "name": "Neagota Florin"},
                "status": "Depozitat în Lift ",
                "stance": "",
                "isInStorage": true,
                "registeredCycles": null,
                "registeredTime": null,
                "comment": null
            }, {
                "id": 5774,
                "toolUid": "0980fce3-817c-44bc-be8b-af8cda4b1840",
                "name": "Purtatori FOI Volvo Trucks AB12",
                "mesCode": "N/A",
                "liftNumber": "22",
                "liftShelf": 3,
                "cart": 1,
                "shelfPosition": "A",
                "isAvailableForManufactoring": true,
                "notAvailableReason": null,
                "isDeleted": false,
                "shouldBeReplaced": false,
                "mainLine": {"id": 13, "name": "AB12_FA2"},
                "owner": {"id": 35, "name": "Neagota Florin"},
                "status": "Depozitat în Lift ",
                "stance": "",
                "isInStorage": true,
                "registeredCycles": null,
                "registeredTime": null,
                "comment": null
            }]
        }]
    }, {
        "tools": [{
            "id": 6445,
            "toolUid": "75c1e1be-5a8f-4bbe-b3af-9a5c06144f78",
            "name": "EOL Tester JLR FlexRay 0001 AB12 FA2",
            "mesCode": "553",
            "liftNumber": "22",
            "liftShelf": 8,
            "cart": 1,
            "shelfPosition": "E",
            "isAvailableForManufactoring": true,
            "notAvailableReason": null,
            "isDeleted": false,
            "shouldBeReplaced": false,
            "mainLine": {"id": 13, "name": "AB12_FA2"},
            "owner": {"id": 1479, "name": "BUR2CLJ Budean"},
            "status": "Depozitat în Lift ",
            "stance": "",
            "isInStorage": true,
            "registeredCycles": null,
            "registeredTime": null,
            "comment": null
        }]
    }, {
        "tools": [{
            "id": 6660,
            "toolUid": "c2afd9f3-c849-4e62-8086-92b5085ae48f",
            "name": "EOL Tester Daimler MRA 0002 AB12",
            "mesCode": "N/A",
            "liftNumber": "220",
            "liftShelf": 1,
            "cart": 0,
            "shelfPosition": "C",
            "isAvailableForManufactoring": true,
            "notAvailableReason": null,
            "isDeleted": false,
            "shouldBeReplaced": false,
            "mainLine": {"id": 12, "name": "AB12_FA1"},
            "owner": {"id": 1479, "name": "BUR2CLJ Budean"},
            "status": "Depozitat în Lift ",
            "stance": "",
            "isInStorage": true,
            "registeredCycles": null,
            "registeredTime": null,
            "comment": null
        }]
    }, {
        "tools": [{
            "id": 6666,
            "toolUid": "ce5f96c6-dcba-4335-875f-edc7810469bc",
            "name": "EOL Tester VW 0003 AB12",
            "mesCode": "N/A",
            "liftNumber": "22",
            "liftShelf": 2,
            "cart": 0,
            "shelfPosition": "B",
            "isAvailableForManufactoring": true,
            "notAvailableReason": null,
            "isDeleted": false,
            "shouldBeReplaced": false,
            "mainLine": {"id": 13, "name": "AB12_FA2"},
            "owner": {"id": 1479, "name": "BUR2CLJ Budean"},
            "status": "Depozitat în Lift ",
            "stance": "",
            "isInStorage": true,
            "registeredCycles": null,
            "registeredTime": null,
            "comment": null
        }]
    }, {
        "tools": [{
            "id": 6669,
            "toolUid": "1ebe86a3-083a-438e-91ca-fc091fb3da62",
            "name": "EOL Tester Volvo CMA 0002 AB12",
            "mesCode": "N/A",
            "liftNumber": "22",
            "liftShelf": 4,
            "cart": 0,
            "shelfPosition": "A",
            "isAvailableForManufactoring": true,
            "notAvailableReason": null,
            "isDeleted": false,
            "shouldBeReplaced": true,
            "reasonForReplacement": "atom.tool-requests-lines.replaceTools.unavailabilityReason.atOtherLine",
            "mainLine": {"id": 13, "name": "AB12_FA2"},
            "owner": {"id": 1479, "name": "BUR2CLJ Budean"},
            "status": "La Linie",
            "stance": "La linia AB12_FA2",
            "isInStorage": false,
            "registeredCycles": null,
            "registeredTime": null,
            "comment": null
        }]
    }, {
        "tools": [{
            "id": 6672,
            "toolUid": "ed6c1988-7971-4b8a-b64f-210153ffc9eb",
            "name": "EOL Tester JLR FlexRay 0002 AB12 FA2",
            "mesCode": "553",
            "liftNumber": "40",
            "liftShelf": 13,
            "cart": 0,
            "shelfPosition": "d",
            "isAvailableForManufactoring": true,
            "notAvailableReason": null,
            "isDeleted": false,
            "shouldBeReplaced": false,
            "mainLine": {"id": 13, "name": "AB12_FA2"},
            "owner": {"id": 1479, "name": "BUR2CLJ Budean"},
            "status": "Depozitat în Lift ",
            "stance": "",
            "isInStorage": true,
            "registeredCycles": null,
            "registeredTime": null,
            "comment": null
        }]
    }, {
        "tools": [{
            "id": 7903,
            "toolUid": "f56d28e2-b5f4-453c-9954-969b5aefb99c",
            "name": "EOL Tester Volvo AD 0002 AB12",
            "mesCode": "N/A",
            "liftNumber": "24",
            "liftShelf": 5,
            "cart": 1,
            "shelfPosition": "C",
            "isAvailableForManufactoring": true,
            "notAvailableReason": null,
            "isDeleted": false,
            "shouldBeReplaced": false,
            "mainLine": {"id": 12, "name": "AB12_FA1"},
            "owner": {"id": 1479, "name": "BUR2CLJ Budean"},
            "status": "Depozitat în Lift ",
            "stance": "",
            "isInStorage": true,
            "registeredCycles": null,
            "registeredTime": null,
            "comment": null
        }]
    }]
}



